import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import {
  MachineGroupRoutingPath,
  UpdateRoutingPathPayload,
} from "@src/types/namespace-configuration";

export interface UpdateRoutingPathResult {
  success: boolean;
  data?: MachineGroupRoutingPath;
  error?: string;
}

export const updateRoutingPathUseCase = async (
  pathId: string,
  payload: UpdateRoutingPathPayload,
): Promise<UpdateRoutingPathResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const routingPath = await apiUseCases.putUpdateRoutingPath(
      namespace,
      pathId,
      payload,
    );

    return {
      success: true,
      data: routingPath,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update routing path").message,
    };
  }
};
